import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  CognitoUser,
  CognitoUserAttribute,
  CognitoUserPool,
} from 'amazon-cognito-identity-js';
import { environment } from 'src/environments/environment';

export class CognitoBase {
  userPool: CognitoUserPool;
  cognitoUser?: CognitoUser;
  userAttributes: any;
  requiredAttributes: any;

  protected router = inject(Router);
  constructor() {
    this.userPool = new CognitoUserPool({
      ClientId: environment.cognito.userClientId,
      UserPoolId: environment.cognito.userPoolId,
      endpoint: environment.cognito.apiRest,
    });
  }
  protected mapToCognitoUserAttribute(userAttributes: {
    [key: string]: any;
  }): CognitoUserAttribute[] {
    return Object.entries(userAttributes).map(([attrName, value]) => {
      if (attrName === 'email') {
        return new CognitoUserAttribute({
          Name: 'preferred_username',
          Value: value,
        });
      }
      return new CognitoUserAttribute({ Name: attrName, Value: value });
    });
  }

  protected ensureAuthenticated(user: CognitoUser): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!user) {
        this.router.navigate(['/login']);
        reject('User is not authenticated');
      }

      user.getSession((err: any, session: any) => {
        if (err || !session.isValid()) {
          this.router.navigate(['/login']);
          reject('User session is not valid');
        } else {
          resolve();
        }
      });
    });
  }

  protected getErrorMessage(code: string): string {
    switch (code) {
      case 'UserNotFoundException':
        return 'Usuário não encontrado';
      case 'NotAuthorizedException':
        return 'Usuário ou senha inválidos ou usuário está desabilitado';
      case 'UserNotConfirmedException':
        return 'Usuário não confirmado';
      case 'CodeMismatchException':
        return 'Código inválido';
      case 'LimitExceededException':
        return 'Limite de tentativas excedido, tente novamente mais tarde';
      case 'TooManyRequestsException':
        return 'Muitas solicitações, tente novamente mais tarde';
      case 'PasswordResetRequiredException':
        return 'É necessário redefinir a senha';
      case 'InvalidPasswordException':
        return 'Senha inválida';
      case 'InvalidParameterException':
        return 'Parâmetro inválido';
      case 'UsernameExistsException':
        return 'E-mail já cadastrado';
      case 'ResourceNotFoundException':
        return 'Recurso não encontrado';
      case 'CodeDeliveryFailureException':
        return 'Falha na entrega do código';
      case 'InvalidLambdaResponseException':
        return 'Resposta Lambda inválida';
      case 'UnexpectedLambdaException':
        return 'Exceção Lambda inesperada';
      case 'InvalidUserPoolConfigurationException':
        return 'Configuração inválida do pool de usuários';
      case 'MFAMethodNotFoundException':
        return 'Método MFA não encontrado';
      case 'TooManyFailedAttemptsException':
        return 'Muitas tentativas falhadas';
      case 'ExpiredCodeException':
        return 'Código inválido ou expirado';
      default:
        return 'Serviço indisponível. Por favor, tente novamente mais tarde';
    }
  }
}
